import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const MediaRowEntityExtraSchema = z.object({
  adformCampaignId: z.string().nullish(),
  adformIsRtb: z.boolean().nullish(),
});

export const MediaRowEntityItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  extra: MediaRowEntityExtraSchema.nullish(),
});

export const MediaRowEntitiesResponseSchema = createResponseSchema(
  MediaRowEntityItemSchema,
);

export type MediaRowEntityItemType = z.infer<typeof MediaRowEntityItemSchema>;
export type MediaRowEntitiesResponseType = z.infer<
  typeof MediaRowEntitiesResponseSchema
>;
